import BusinessIcon from "@mui/icons-material/Business";
import PolicyIcon from "@mui/icons-material/Security";
import { FilterList, FilterListItem, FilterLiveSearch, SavedQueriesList } from "react-admin";
import { StyledListAside } from "@/components/ui/react-admin/StyledListAside";

export const VendorsListAside = () => {
  return (
    <StyledListAside>
      <FilterLiveSearch />
      <SavedQueriesList />

      {/* Vendor Type Filter */}
      <FilterList label="Vendor Type" icon={<BusinessIcon />}>
        <FilterListItem label="Stop-Loss Carrier" value={{ is_sl_carrier: true }} />
        <FilterListItem label="TPA" value={{ is_tpa: true }} />
        <FilterListItem label="BUCA TPA" value={{ tpa_is_buca: true }} />
        <FilterListItem label="Rx Vendor" value={{ is_rx_vendor: true }} />
      </FilterList>

      {/* Policy Association Filter */}
      <FilterList label="Policy Association" icon={<PolicyIcon />}>
        <FilterListItem label="Has Active Policy" value={{ has_active_policy: true }} />
        <FilterListItem label="No Active Policy" value={{ has_active_policy: false }} />
      </FilterList>
    </StyledListAside>
  );
};
